import React from "react";
import AnimatedAllRoute from "../../components/AnimateRoute/AnimateRoute";
import { BrowserRouter } from "react-router-dom";

const AllRoute = ({ isDark, onToggleDark }) => {
  return (
    <div className="App">
      <BrowserRouter>
        <AnimatedAllRoute isDark={isDark} onToggleDark={onToggleDark} />
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
